import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enProductsScreenTranslation from './locales/en/productsscreen.json';
import enCategoriesScreenTranslation from './locales/en/categoriesscreen.json';
import enSalesChannelsScreenTranslation from './locales/en/saleschannelsscreen.json';
import enSalesChannelFormTranslation from './locales/en/saleschannelform.json';
import enProductScreenTranslation from './locales/en/productscreen.json';
import enBundleScreenTranslation from './locales/en/bundlescreen.json';
import enCategoryModalTranslation from './locales/en/categorymodal.json';
import enAdminSettingsTranslation from './locales/en/adminSettings.json';
import enHeaderTranslation from './locales/en/header.json';
import enEditableItemTranslation from './locales/en/editableItem.json';
import enEditingLocaleTranslation from './locales/en/editingLocale.json';
import enSectionsTranslation from './locales/en/sections.json';
import enErrorCodesTranslation from './locales/en/errorCodes.json';
import enBundlesViewTranslation from './locales/en/bundlesview.json';

i18next.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  debug: true, // TODO: false in production,
  returnObjects: true,
  resources: {
    en: {
      editableItem: enEditableItemTranslation,
      editingLocale: enEditingLocaleTranslation,
      sections: enSectionsTranslation,
      header: enHeaderTranslation,
      productsscreen: enProductsScreenTranslation,
      categoriesscreen: enCategoriesScreenTranslation,
      saleschannelsscreen: enSalesChannelsScreenTranslation,
      productscreen: enProductScreenTranslation,
      bundlescreen: enBundleScreenTranslation,
      categorymodal: enCategoryModalTranslation,
      saleschannelform: enSalesChannelFormTranslation,
      adminSettings: enAdminSettingsTranslation,
      errorCodes: enErrorCodesTranslation,
      bundlesview: enBundlesViewTranslation,
    },
  },
});
